<div *transloco="let t">
<div class="title">{{ t('additionalResources') }}</div>
<app-additionalresourcecard [list]="list"></app-additionalresourcecard>
</div>
